import React from "react";

export default function ColorFrame11({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          d="M29.3127 46.4383C29.3127 41.6403 33.2023 37.7507 38.0004 37.7507H58.0537C62.8518 37.7507 66.7414 41.6403 66.7414 46.4383V100.569C66.7414 107.951 60.7574 113.935 53.3757 113.935H42.6784C35.2967 113.935 29.3127 107.951 29.3127 100.569V46.4383Z"
          fill="#399390"
        />
        <path
          d="M2 111.131C2 96.9892 10.9021 84.3791 24.2274 79.6448L31.1673 77.1791H66.5728L72.5124 79.4052C85.5684 84.2984 94.2136 96.7842 94.1998 110.727L94.0674 244.263C94.0601 251.639 88.0782 257.615 80.7018 257.615H15.3656C7.98399 257.615 2 251.631 2 244.249V111.131Z"
          fill="#399390"
        />
        <mask
          id="mask0_2087_156947"
          style={{ maskType: "alfa" }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="77"
          width="93"
          height="181"
        >
          <path
            d="M2 111.131C2 96.9892 10.9021 84.3791 24.2274 79.6448L31.1673 77.1791H66.5728L72.5124 79.4052C85.5684 84.2984 94.2136 96.7842 94.1998 110.727L94.0674 244.263C94.0601 251.639 88.0782 257.615 80.7018 257.615H15.3656C7.98399 257.615 2 251.631 2 244.249V111.131Z"
            fill="#399390"
          />
        </mask>
        <g mask="url(#mask0_2087_156947)">
          <path
            d="M10.0927 88.802C18.5226 90.0212 23.0747 86.6685 30.3244 85.4493C37.5741 84.2302 42.4634 85.4494 51.2305 88.802C59.9975 92.1547 60.6719 91.1994 67.753 89.9803C74.8341 88.7611 78.2061 85.4493 84.95 85.4493C91.6938 85.4494 101.304 92.7234 101.304 92.7234L94.5969 250.911C94.2935 258.066 88.4047 263.711 81.2433 263.711H15.2886C7.93713 263.711 1.96571 257.774 1.9232 250.422L0.988464 88.802C0.988464 88.802 1.66285 87.5828 10.0927 88.802Z"
            fill="#2B7D7B"
          />
        </g>
        <rect
          x="33.3591"
          y="13.6924"
          width="28.9987"
          height="24.0581"
          rx="6.68281"
          fill="#5F3A59"
        />
        <rect
          x="10.6876"
          y="118.613"
          width="74.8475"
          height="120.959"
          rx="8.01937"
          fill="#FFE09E"
        />
        <path
          d="M206.354 34.7458C206.354 29.9477 210.244 26.0581 215.042 26.0581H235.095C239.893 26.0581 243.783 29.9477 243.783 34.7458V88.8766C243.783 96.2582 237.799 102.242 230.417 102.242H219.72C212.338 102.242 206.354 96.2582 206.354 88.8765V34.7458Z"
          fill="#4081A5"
        />
        <path
          d="M179.041 99.4382C179.041 85.2968 187.943 72.6867 201.269 67.9523L208.208 65.4867H243.614L249.554 67.7128C262.61 72.606 271.255 85.0917 271.241 99.0346L271.109 232.57C271.101 239.947 265.119 245.922 257.743 245.922H192.407C185.025 245.922 179.041 239.938 179.041 232.557V99.4382Z"
          fill="#4081A5"
        />
        <mask
          id="mask1_2087_156947"
          style={{ maskType: "alfa" }}
          maskUnits="userSpaceOnUse"
          x="179"
          y="65"
          width="93"
          height="181"
        >
          <path
            d="M179.041 99.4382C179.041 85.2968 187.943 72.6867 201.269 67.9523L208.208 65.4867H243.614L249.554 67.7128C262.61 72.606 271.255 85.0917 271.241 99.0346L271.109 232.57C271.101 239.947 265.119 245.922 257.743 245.922H192.407C185.025 245.922 179.041 239.938 179.041 232.557V99.4382Z"
            fill="#399390"
          />
        </mask>
        <g mask="url(#mask1_2087_156947)">
          <path
            d="M187.134 77.1096C195.564 78.3287 200.116 74.976 207.366 73.7569C214.615 72.5377 219.505 73.7569 228.272 77.1096C237.039 80.4622 237.713 79.507 244.794 78.2878C251.875 77.0687 255.247 73.7569 261.991 73.7569C268.735 73.7569 278.345 81.0309 278.345 81.0309L271.638 239.219C271.335 246.374 265.446 252.018 258.284 252.018H192.33C184.978 252.018 179.007 246.081 178.964 238.73L178.03 77.1096C178.03 77.1096 178.704 75.8904 187.134 77.1096Z"
            fill="#1A587A"
          />
        </g>
        <rect
          x="210.4"
          y="2"
          width="28.9987"
          height="24.0581"
          rx="6.68281"
          fill="#FFE3A6"
        />
        <rect
          x="187.729"
          y="106.92"
          width="74.8475"
          height="120.959"
          rx="8.01937"
          fill="#E2A5FF"
        />
        <path
          d="M109.237 69.5012C109.237 62.1196 115.221 56.1356 122.603 56.1356H170.051C177.433 56.1356 183.417 62.1196 183.417 69.5012V118.954C183.417 126.336 177.433 132.32 170.051 132.32H122.603C115.221 132.32 109.237 126.336 109.237 118.954V69.5012Z"
          fill="#90CAC8"
        />
        <path
          d="M55.1066 117.036C55.1066 101.066 66.4069 87.3287 82.0769 84.2491L112.913 78.1888H183.082L211.202 84.0184C226.733 87.2385 237.861 100.935 237.833 116.797L237.571 262.658C237.558 270.031 231.578 276 224.206 276H68.4722C61.0905 276 55.1066 270.016 55.1066 262.634V117.036Z"
          fill="#90CAC8"
        />
        <mask
          id="mask2_2087_156947"
          style={{ maskType: "alfa" }}
          maskUnits="userSpaceOnUse"
          x="55"
          y="78"
          width="183"
          height="198"
        >
          <path
            d="M55.1066 117.036C55.1066 101.066 66.4069 87.3287 82.0769 84.2491L112.913 78.1888H183.082L211.202 84.0184C226.733 87.2385 237.861 100.935 237.833 116.797L237.571 262.658C237.558 270.031 231.578 276 224.206 276H68.4722C61.0905 276 55.1066 270.016 55.1066 262.634V117.036Z"
            fill="#FFB7DE"
          />
        </mask>
        <g mask="url(#mask2_2087_156947)">
          <path
            d="M71.1453 90.9311C87.8524 92.2676 96.8741 88.5921 111.242 87.2555C125.61 85.919 135.3 87.2556 152.676 90.9311C170.051 94.6066 171.387 93.5593 185.421 92.2228C199.455 90.8862 206.138 87.2555 219.504 87.2555C232.869 87.2556 251.915 95.23 251.915 95.23L238.493 270.339C237.96 277.304 232.152 282.683 225.167 282.683H68.3332C61.0061 282.683 55.0449 276.784 54.9683 269.457L53.1017 90.9311C53.1017 90.9311 54.4383 89.5945 71.1453 90.9311Z"
            fill="#53AFAC"
          />
        </g>
        <rect
          x="117.257"
          y="32.0775"
          width="57.4722"
          height="24.0581"
          rx="6.68281"
          fill="#893976"
        />
        <rect
          x="67.4699"
          y="110.601"
          width="158.383"
          height="145.685"
          rx="6.34867"
          fill="white"
          stroke="#53AFAC"
          strokeWidth="3.3414"
        />
        <rect
          x="80.5012"
          y="117.617"
          width="131.651"
          height="131.651"
          fill="white"
        />
        {children}
      </g>
    </svg>
  );
}
